var angular = require('angular');
var _module = angular.module('listreports.loading-screen', []);


_module
    .directive('loadingScreen', [
        function() {
            return {
                restrict: 'E',
                templateUrl: 'js/components/loading-screen/templates/loading-screen.tmpl.html',
                replace: true,
                link: function($scope, elem, attrs) {
                    $scope.$showLoadingScreen = true;

                    // $watch Functions
                    $scope.$watch(attrs.show, function(newValue, oldValue) {
                        $scope.$showLoadingScreen = newValue;
                    });
                }
            };
        }
    ])
;